<template>
  <div
    class="border-b border-t grid grid-rows-[auto_1fr] md:border md:shadow-lg md:w-[25rem] md:rounded-b-lg overflow-hidden"
  >
    <div class="flex flex-row [&>a]:flex-1 [&>a:not(:last-of-type)]:border-r">
      <NuxtLinkLocale
        v-for="view in views"
        :locale="switchBlogLocale()"
        :to="`/account/${view.key}`"
        class="text-center flex flex-row justify-center text-primary items-center gap-1 border-b p-3 py-4 font-semibold text-sm"
        :class="{
          'bg-white border-b-0 text-secondary': view.active,
        }"
      >
        <Component :is="view.icon" class="shrink-0 w-[1.3em] h-[1.3em]" />
        <span class="text-black">{{ view.label }}</span>
      </NuxtLinkLocale>
    </div>
    <div
      v-for="view in views"
      class="bg-white p-3 max-w-full overflow-auto"
      :class="{
      hidden: !view.active,
      }"
      :id="view.key"
    >
      <Component :is="view.component" v-if="view.active" />
    </div>
  </div>
</template>

<script setup lang="ts">
  import LoggedInUser from '~/components/icons/LoggedInUser.vue';
  import Login from "../views/login.vue";
  import Signup from "../views/signup.vue";
  
  const { t } = useI18n();
  
const route = useRoute();
const params = computed(() => route.params as { page: string });

const views = computed(() => [
  {
    key: "login",
    get active() {
      return params.value.page === this.key;
    },
    component: Login,
    icon: LoggedInUser,
    label: t("buttons.common.login"),
  },
  {
    key: "signup",
    get active() {
      return params.value.page === this.key;
    },
    component: Signup,
    icon: LoggedInUser,
    label: t("pages.account.login.buttons.create_account"),
  },
]);
</script>
